import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { ProgressStepperStepLabelTextMixin } from '../../mixins/components/ProgressStepperStepLabelTextMixin';
export var StyledProgressStepperStepLabelText = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledProgressStepperStepLabelText",
  componentId: "c11n-8-64-0__sc-7ulp8g-0"
})(["", ""], ProgressStepperStepLabelTextMixin);
/**
 * Used by [`ProgressStepperStep`](#/More%20components?id=progressstepperstep) to wrap
 * a step's label text.
 *
 * @since 8.57.0
 */

var ProgressStepperStepLabelText = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledProgressStepperStepLabelText, _extends({
    ref: ref
  }, props));
});
export default ProgressStepperStepLabelText;